module.exports = __webpack_public_path__ + "img/Gruppenführer_Verpflegung.65c77d8c.svg";